import { isEqual } from 'lodash';
import { createContext, useContext, useMemo,useState } from 'react';

import Meta from '../components/Atoms/Meta';

const defaultState = {
  title: '',
  language: 'en',
};

export const MetaContext = createContext({
  setMeta: () => {},
  setNotificationCount: () => {},
});

export const useMeta = () => useContext(MetaContext);

export const MetaProvider = ({ children }) => {
  const [meta, setMeta] = useState(defaultState);
  const [notificationCount, setNotificationCount] = useState(0);

  const handleMetaChange = async (values, flush = true) => {
    const newMeta = {
      ...defaultState,
      ...(flush === false ? meta : {}),
      ...(values ? values : {}),
    };

    if (!isEqual(meta, newMeta)) {
      setMeta(newMeta);
    }
  };

  const handleNotificationCountChange = async (value = 0) => {
    const newNotificationCount = value > 0 ? value : 0;
    setNotificationCount(newNotificationCount);
  };

  const actions = useMemo(
    () => ({
      setMeta: handleMetaChange,
      setNotificationCount: handleNotificationCountChange,
    }),
    []
  );

  return (
    <MetaContext.Provider value={actions}>
      {children}
      <Meta {...meta} notificationCount={notificationCount} />
    </MetaContext.Provider>
  );
};
